import React, { Component } from "react";
import { Col, Form, Row, Button } from "antd";
import {
  DownloadOutlined,
  FileImageOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import "./styles.css";
import { UIUpload } from "../../../components";

class Atestados extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reppFile: null,
      ptrpFile: null,
    };

    this.uploadRepp = null;
    this.uploadPtrp = null;
  }

  init = (item) => {
    if (!item) return;

    // RP-P
    if (item.rep_p_file) {
      const reppFileObj = {
        url: item.rep_p_file,
        uuid: null,
        type: this.getMimeType(item.rep_p_file),
      };
      if (this.uploadRepp) {
        this.uploadRepp.setFiles([reppFileObj]);
      }
      this.setState({ reppFile: reppFileObj });
    } else {
      this.setState({ reppFile: null });
    }

    // PTRP
    if (item.ptrp_file) {
      const ptrpFileObj = {
        url: item.ptrp_file,
        uuid: null,
        type: this.getMimeType(item.ptrp_file),
      };
      if (this.uploadPtrp) {
        this.uploadPtrp.setFiles([ptrpFileObj]);
      }
      this.setState({ ptrpFile: ptrpFileObj });
    } else {
      this.setState({ ptrpFile: null });
    }
  };

  getMimeType = (url) => {
    if (!url) return "application/octet-stream";

    const ext = url.split(".").pop().toLowerCase();

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        return "image/" + (ext === "jpg" ? "jpeg" : ext);
      case "pdf":
        return "application/pdf";
      default:
        return "application/octet-stream";
    }
  };

  getFileExtension = (url) => {
    if (!url) return "";
    return url.split(".").pop().toUpperCase();
  };

  getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  handleDownload = (fileUrl, fileName) => {
    if (!fileUrl) return;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", fileName);
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  renderFilePreview = (file, label) => {
    if (!file || !file.url) {
      return (
        <div className="file-empty-state">
          <FileImageOutlined style={{ fontSize: 20, color: "#bfbfbf" }} />
          <span className="empty-text">Nenhum arquivo anexado</span>
        </div>
      );
    }

    const isImage = file.type.startsWith("image/");
    const isPdf = file.type === "application/pdf";
    const extension = this.getFileExtension(file.url);
    const fileName = this.getFileName(file.url);

    return (
      <div className="file-preview-card">
        <div className="file-icon">
          {isImage ? (
            <FileImageOutlined style={{ fontSize: 24, color: "#1890ff" }} />
          ) : isPdf ? (
            <FilePdfOutlined style={{ fontSize: 24, color: "#ff4d4f" }} />
          ) : (
            <FileImageOutlined style={{ fontSize: 24, color: "#1890ff" }} />
          )}
          <span className="file-extension">{extension}</span>
        </div>
        <div className="file-info">
          <div className="file-name" title={fileName}>
            {fileName.length > 30
              ? fileName.substring(0, 30) + "..."
              : fileName}
          </div>
        </div>
        <Button
          type="text"
          icon={<DownloadOutlined />}
          onClick={() => this.handleDownload(file.url, fileName)}
          className="download-button"
        >
          Baixar
        </Button>
      </div>
    );
  };

  render() {
    const { reppFile, ptrpFile } = this.state;

    return (
      <div style={{ marginTop: 20 }}>
        <Row gutter={[16, 24]}>
          <Col span={24}>
            <div className="atestado-section">
              <div className="atestado-label">REP-P</div>
              {this.renderFilePreview(reppFile, "RP-P")}
              <div style={{ display: "none" }}>
                <Form.Item>
                  <UIUpload
                    ref={(el) => (this.uploadRepp = el)}
                    multiple={false}
                    disabled
                    acceptedFiles={["pdf", "jpg", "jpeg", "png"]}
                    labelError="arquivo RP-P"
                  />
                </Form.Item>
              </div>
            </div>
          </Col>

          <Col span={24}>
            <div className="atestado-section">
              <div className="atestado-label">PTRP</div>
              {this.renderFilePreview(ptrpFile, "PTRP")}
              <div style={{ display: "none" }}>
                <Form.Item>
                  <UIUpload
                    ref={(el) => (this.uploadPtrp = el)}
                    multiple={false}
                    disabled
                    acceptedFiles={["pdf", "jpg", "jpeg", "png"]}
                    labelError="arquivo PTRP"
                  />
                </Form.Item>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Atestados;
